module.exports = __webpack_public_path__ + "graphics/player-hide-chevron.ckh.acff962e21270857ece0ff34c2130ad8.svg";